module.exports = __webpack_public_path__ + "img/thanq_logo2.bf5aa36e.svg";